var map = {
	"./1.png": 3445,
	"./2.png": 4269,
	"./3.png": 3798,
	"./4.png": 2515,
	"./cloud-2.png": 5927,
	"./cloud-bg.png": 7282,
	"./cloud.png": 2392,
	"./facebook.png": 6130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1333;